import React, { useState, useRef } from 'react'

export default function useControlled({ controlled, default: defaultProp }) {
	const { current: isControlled } = useRef(controlled !== undefined)
	const [valueState, setValue] = useState(defaultProp)
	const value = isControlled ? controlled : valueState

	const setValueIfUncontrolled = React.useCallback((newValue) => {
		if (!isControlled) {
			setValue(newValue)
		}
	}, [])

	return [value, setValueIfUncontrolled]
}
